<template>
    <li class="stuff-item">
        <div class="stuff-content">
            <img :src="detail.cover" :alt="detail.productName" class="stuff-img">
        </div>
        <button
            class="stuff-btn"
            :class="{ 'stuff-btn-disabled': disabled }"
            :disabled="disabled"
            @click="handleUse">
            赠送
        </button>
    </li>
</template>

<script>
import { AssetStatus } from '@/constants/mall'

export default {
    name: "StuffItem",
    props: {
        detail: {
            type: Object,
            default: () => ({}),
        },
    },
    data() {
        return {
            AssetStatus,
        }
    },
    computed: {
        disabled() {
            return  this.detail.status === AssetStatus.USED
        }
    },
    methods: {
        async handleUse() {
            this.$emit('used', this.detail)
        }
    }
}
</script>

<style scoped>
.stuff-item {
    position: relative;
    display: flex;
    align-items: center;
    flex-direction: column;
}
.stuff-used {
    position: absolute;
    top: 0;
    right: 0;
    width: 40px;
    height: 40px;
}
.stuff-content {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 8px;
    background: #fff3d3;
    border-radius: 28px
}
.stuff-img {
    width: 152px;
    height: 168px;
    object-fit: cover;
    border-radius: 30px;
}
.stuff-name {
    margin-top: 2px;
    font-size: 30px;
    font-weight: bold;
    color: #6F6C68;
}
.stuff-btn {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 163px;
    height: 49px;
    margin-top: 8px;
    background: #ffe952;
    border: 0;
    border-radius: 24px;
    box-shadow: 0px 1px 3px 0px rgba(153,37,6,0.41), 0px -3px 4px 0px #ffbe31 inset; 
    color: #DD7146;
    font-size: 24px;
    font-weight: bold;
}
.stuff-btn-disabled {
    background: #fff3d3;
    box-shadow: 0px 1px 3px 0px rgba(153,37,6,0.41), 0px -3px 4px 0px #ecc596 inset; 
    color: #B18F54;
}
</style>